import styled from 'styled-components';
export const AppBpDataGrid = styled.div `
  .MuiIconButton-root:hover {
    border-radius: 4px;
    background-color: #F1F7FF;
    -webkit-transition: 'none';
    transition:'none';
  }
  .MuiIconButton-root {
    border-radius: 4px;
    -webkit-transition: 'none';
    transition:'none';
    width: 40px;
    height: 40px;
  }
  .MuiDataGrid-row:hover {
    background-color: #F2F2F2;
  }
  .MuiDataGrid-columnHeaders{
    z-index: 1
  }
  .Mui-selected{
    background-color: #F1F7FF !important;
  }
`;
